import { cartItemsToSizebayProducts } from './utils/products'

export const checkoutPurchase = ({
	currency,
	order,
	billingAddress: { countryCode: billingCountryCode } = {},
	shippingAddress: { countryCode: shippingCountryCode } = {},
	config: {
		defaultCountry,
		sizebay: { tenantId },
	},
	config,
	store,
}) => {
	try {
		if (typeof window.Sizebay.events.ordered === 'function') {
			const payload = {
				orderId: order.id,
				currency,
				country: shippingCountryCode ?? billingCountryCode ?? defaultCountry,
				items: cartItemsToSizebayProducts({ items: order.items, config, store }),
			}
			window.Sizebay.events.ordered(payload, tenantId)
		}
	} catch (e) {
		console.error(e)
	}
}
